
(function(){
  function fmt(cents){
    var f=window.vsMoneyFormat||'${{amount}}', m=f.match(/\{\{\s*(\w+)\s*\}\}/), t=m?m[1]:'amount';
    function d(n,p,th,de){var s=(n/100).toFixed(p).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);return s[0]+(s[1]?de+s[1]:'');}
    var v={amount_no_decimals:d(cents,0,',','.'),amount_with_comma_separator:d(cents,2,'.',','),
      amount_no_decimals_with_comma_separator:d(cents,0,'.',','),amount_with_apostrophe_separator:d(cents,2,"'",'.')}[t]||d(cents,2,',','.');
    return f.replace(/\{\{\s*\w+\s*\}\}/,v);
  }
  var S={variant:0,price:0,compare:0,qty:1,available:true,root:'/'};
  function render(){
    document.querySelectorAll('[data-vs-now]').forEach(function(n){n.innerHTML=fmt(S.price*S.qty)});
    var on=S.compare>S.price;
    document.querySelectorAll('[data-vs-was]').forEach(function(n){n.innerHTML=on?fmt(S.compare*S.qty):'';n.hidden=!on});
    document.querySelectorAll('[data-vs-save]').forEach(function(n){n.hidden=!on;if(on)n.textContent='SAVE '+Math.round((S.compare-S.price)*100/S.compare)+'%'});
    document.querySelectorAll('.vs-bundle').forEach(function(b){
      var q=+b.dataset.qty||1, bn=b.querySelector('[data-vs-bnow]'), bw=b.querySelector('[data-vs-bwas]');
      if(bn) bn.innerHTML=fmt(S.price*q); if(bw){bw.innerHTML=on?fmt(S.compare*q):'';bw.hidden=!on}
    });
    document.querySelectorAll('[data-vs-buy]').forEach(function(a){
      a.href=S.root+'cart/'+S.variant+':'+S.qty; a.classList.toggle('vs-soldout',!S.available);
    });
  }
  function init(){
    var main=document.querySelector('.vs-product');
    if(main){
      S.variant=+main.dataset.variant; S.price=+main.dataset.price; S.compare=+main.dataset.compare||0;
      S.available=main.dataset.available!=='false'; S.root=main.dataset.root||'/';
    }
    // gallery
    document.querySelectorAll('.vs-gallery').forEach(function(g){
      if(g.dataset.vsBound) return; g.dataset.vsBound=1;
      var img=g.querySelector('.vs-main-img');
      g.querySelectorAll('.vs-thumbs button').forEach(function(b){b.addEventListener('click',function(){
        g.querySelectorAll('.vs-thumbs button').forEach(function(x){x.classList.remove('is-active')});
        b.classList.add('is-active'); if(img){img.removeAttribute('srcset');img.src=b.dataset.full;}
      })});
    });
    // bundles
    var bundles=document.querySelectorAll('.vs-bundle');
    var sel=document.querySelector('.vs-bundle.is-sel'); S.qty=sel?(+sel.dataset.qty||1):1;
    bundles.forEach(function(el){ if(el.dataset.vsBound) return; el.dataset.vsBound=1;
      el.addEventListener('click',function(){
        bundles.forEach(function(x){x.classList.remove('is-sel')}); el.classList.add('is-sel');
        var r=el.querySelector('input'); if(r) r.checked=true; S.qty=+el.dataset.qty||1; render();
      });
    });
    // variants
    var vs=document.querySelector('.vs-variant select');
    if(vs&&!vs.dataset.vsBound){ vs.dataset.vsBound=1; vs.addEventListener('change',function(){
      var o=vs.options[vs.selectedIndex]; S.variant=+o.value; S.price=+o.dataset.price; S.compare=+o.dataset.compare||0;
      S.available=o.dataset.available!=='false'; if(main) main.dataset.variant=S.variant;
      if(o.dataset.image){var im=document.querySelector('.vs-main-img'); if(im){im.removeAttribute('srcset');im.src=o.dataset.image;}}
      render();
    });}
    // buy: same route as the theme cart drawer (cart -> /checkout); clears old items first; falls back to the direct link
    document.querySelectorAll('[data-vs-buy]').forEach(function(a){ if(a.dataset.vsBound) return; a.dataset.vsBound=1;
      a.addEventListener('click',function(e){
        e.preventDefault(); if(a.dataset.busy||!S.variant||!S.available) return; a.dataset.busy=1;
        var label=a.innerHTML; a.innerHTML='Loading…';
        var post=function(u,b){return fetch(S.root+u,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(b||{})}).then(function(r){if(!r.ok)throw new Error(r.status);return r.json();});};
        post('cart/clear.js').then(function(){return post('cart/add.js',{items:[{id:S.variant,quantity:S.qty}]});})
          .then(function(){window.location.href=S.root+'checkout';})
          .catch(function(){window.location.href=a.href;})
          .finally(function(){setTimeout(function(){delete a.dataset.busy;a.innerHTML=label;},4000);});
      });
    });
    // mobile sticky bar
    var sticky=document.querySelector('.vs-sticky'), atc=document.querySelector('.vs-product [data-vs-buy]'), fin=document.querySelector('.vs-final');
    document.body.classList.toggle('vs-sticky-on',!!sticky);
    if(sticky&&atc&&'IntersectionObserver' in window&&!sticky.dataset.vsBound){ sticky.dataset.vsBound=1;
      var seen={atc:true,fin:false};
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.target===atc) seen.atc=e.isIntersecting; else seen.fin=e.isIntersecting; });
        sticky.classList.toggle('is-show',!seen.atc && atc.getBoundingClientRect().top<0 && !seen.fin);
      });
      io.observe(atc); if(fin) io.observe(fin);
    }
    render();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:block:select',function(e){var b=e.target&&e.target.closest&&e.target.closest('.vs-bundle'); if(b) b.click();});
})();
